var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_2187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71899 19.2848H7.38566L17.0107 9.66024C17.2514 9.41949 17.4424 9.13369 17.5727 8.81914C17.703 8.50459 17.7701 8.16745 17.7701 7.82699C17.7701 7.48652 17.703 7.14939 17.5727 6.83484C17.4424 6.52029 17.2514 6.23448 17.0107 5.99373C16.7699 5.75299 16.4841 5.56202 16.1695 5.43173C15.855 5.30144 15.5178 5.23437 15.1773 5.23438C14.8368 5.23438 14.4997 5.30144 14.1851 5.43173C13.8706 5.56202 13.5848 5.75299 13.344 5.99373L3.71899 15.6183V19.2848Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4272 6.91016L16.0939 10.5767",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_2187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.999,
    fill: "white",
    transform: "translate(0.0522461 0.951172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.93c92920f53409c5f9cbaf426304eb9f.svg";
export { ForwardRef as ReactComponent };